import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueSignaturePad from 'vue-signature-pad';
import axios from 'axios'
import VueAxios from 'vue-axios'
 
 
Vue.config.productionTip = false
Vue.use(VueSignaturePad);
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
